"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSCheckbox = exports.StyledBGCheckbox = exports.StyledLabel = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var Theme_1 = require("../../../../Theme");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
exports.StyledLabel = styled_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: fit-content;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #3d4046;\n"], ["\n  width: fit-content;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #3d4046;\n"])));
exports.StyledBGCheckbox = styled_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  height: ", "px;\n  color: ", ";\n  box-sizing: border-box;\n  pointer-events: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  height: ", "px;\n  color: ",
    ";\n  box-sizing: border-box;\n  pointer-events: ", ";\n"])), function (props) { return props.size; }, function (props) {
    if (props.isError) {
        return '#e65c5c';
    }
    if (props.checked) {
        if (props.checkColor) {
            return props.checkColor;
        }
        return '#006FFF';
    }
    if (props.fixed) {
        return '#bbbbcc';
    }
    return '#7e8696';
}, function (props) { return (props.disabled ? 'none' : 'auto'); });
var BDSCheckbox = function (props) {
    var style = props.style, _a = props.checked, checked = _a === void 0 ? false : _a, _b = props.fixed, fixed = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.size, size = _d === void 0 ? 20 : _d, onChange = props.onChange, label = props.label;
    var theme = Theme_1.lightTheme;
    return (jsx_runtime_1.jsxs(exports.StyledBGCheckbox, tslib_1.__assign({ theme: theme, onClick: function () {
            if (onChange)
                onChange(!checked);
        }, style: style, size: size, checked: checked, fixed: fixed, disabled: disabled, isError: props.isError, checkColor: props.checkColor }, { children: [jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: !checked ? 'ic-checkbox' : 'ic-checkbox-active', size: size + "px" }, void 0),
            label && jsx_runtime_1.jsx(exports.StyledLabel, { children: label }, void 0)] }), void 0));
};
exports.BDSCheckbox = BDSCheckbox;
var templateObject_1, templateObject_2;
